export interface JourneyChromeContext {
  pageName:
    | "landing-page"
    | "step"
    | "loading"
    | "provider"
    | "secondary-offers-steps"
    | "fiona-secondary-offers"
    | "post"
    | "resources"
    | "";
  provider?: string;
  showSiteHeaderNavigation: boolean;
  showSiteHeaderTrustPilotWidget: boolean;
}

function getPathname(value: string) {
  try {
    return new URL(value, "http://localhost").pathname;
  } catch {
    return value.split("?")[0];
  }
}

export default function deriveChromeContext(
  pathname: string,
): JourneyChromeContext {
  const segments = getPathname(pathname).split("/").filter(Boolean);
  const subPath = segments.slice(1);

  if (subPath.length === 0) {
    return {
      pageName: "landing-page",
      showSiteHeaderNavigation: false,
      showSiteHeaderTrustPilotWidget: true,
    };
  }

  if (subPath[0] === "steps") {
    return {
      pageName: "step",
      showSiteHeaderNavigation: false,
      showSiteHeaderTrustPilotWidget: false,
    };
  }

  if (subPath[0] === "loading") {
    return {
      pageName: "loading",
      showSiteHeaderNavigation: false,
      showSiteHeaderTrustPilotWidget: false,
    };
  }

  if (subPath[0] === "thank-you") {
    return {
      pageName: "provider",
      provider: subPath[1],
      showSiteHeaderNavigation: false,
      showSiteHeaderTrustPilotWidget: false,
    };
  }

  if (subPath[0] === "offers") {
    return {
      pageName:
        subPath[1] === "steps"
          ? "secondary-offers-steps"
          : "fiona-secondary-offers",
      showSiteHeaderNavigation: false,
      showSiteHeaderTrustPilotWidget: false,
    };
  }

  if (subPath[0] === "post") {
    return {
      pageName: "post",
      showSiteHeaderNavigation: true,
      showSiteHeaderTrustPilotWidget: false,
    };
  }

  if (subPath[0] === "resources") {
    return {
      pageName: "resources",
      showSiteHeaderNavigation: true,
      showSiteHeaderTrustPilotWidget: false,
    };
  }

  return {
    pageName: "",
    showSiteHeaderNavigation: true,
    showSiteHeaderTrustPilotWidget: false,
  };
}
